import { LOGIN, ROUTES } from '@/services/api';
import { request, METHOD, removeAuthorization } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/**
 * 获取运输区域列表（#70）
 */
export function getAreaList() {
  return request("".concat(BASE_URL) + "/deliveryArea/list", METHOD.GET);
}

/** 更新收货区域状态数据（#71）
 * @param {Object} data
 */
export function updateAreaStatus(data) {
  return request("".concat(BASE_URL) + "/deliveryArea/status", METHOD.PUT, data);
}

/** 更新收货区域行政单位默认状态数据（#72）
 * @param {Object} id
 */
export function setDefault(id) {
  return request("".concat(BASE_URL) + "/deliveryArea/areaDetailStatus/" + id, METHOD.PUT);
}